'use strict';

class shipmentMethodsService {
  constructor($http) {
    this.$http = $http;
  }

  forRecipient(recipientNumber, documentType, international) {
    return this.$http.get(`/shipment-methods/recipient/${recipientNumber}/${documentType}`, {
      params: {
        international: international
      }
    });
  }

  forReIssue(documentType, documentNumber) {
    return this.$http.get(`/shipment-methods/${documentType}/${documentNumber}`);
  }

  forPreviousDocument(baseDocumentType, baseDocumentNumber, documentType) {
    return this.$http.get(`/shipment-methods/${baseDocumentType}/${baseDocumentNumber}/${documentType}`);
  }
}

shipmentMethodsService.$injext = ['$http'];

angular
  .module('SendRegning')
  .service('shipmentMethodsService', shipmentMethodsService);
